import React, {useEffect, useState} from 'react';
import './workProcess.css';
import {stepsData} from "../../Data";
import { Steps } from "antd";
import Aos from "aos";
import 'aos/dist/aos.css';

function useMediaQuery(query) {
    const [matches, setMatches] = React.useState(() => window.matchMedia(query).matches);
    React.useEffect(() => {
        const mql = window.matchMedia(query);
        const handler = (e) => setMatches(e.matches);
        mql.addEventListener?.("change", handler);
        return () => mql.removeEventListener?.("change", handler);
    }, [query]);
    return matches;
}

const WorkProcess = ({observer, sectionRef}) => {
    const [current, setCurrent] = useState(0);
    const isMobile = useMediaQuery("(max-width: 1500px)");

    useEffect(() => {
        Aos.init({duration:1500})
    }, [])

    useEffect(() => {
        if (observer) {
            observer.observe(sectionRef.current)
        }
    }, [sectionRef, observer])

    const onChange = (value) => {
        setCurrent(value);
    };

    const shorten = (t, n = 40) => (t.length > n ? t.slice(0, n - 1) + "…" : t);

    const items = stepsData.map((s, i) => ({
        title: `${s.title}`,
        description: isMobile ? s.description : "",
    }));

    return (
        <section id='steps' ref={sectionRef}>
            <div data-aos='fade-up' data-aos-duration='2000' className='steps_header'>
                <h2 className="eyebrow">Work process</h2>
                <h1>Steps</h1>
                <p className="steps_intro">A simple, transparent flow from brief to final delivery.</p>
            </div>
            <div data-aos='zoom-in' data-aos-duration='2000' className='container steps_container'>
                <div className="steps_antd">
                    <Steps
                        direction={isMobile ? "vertical" : "horizontal"}
                        labelPlacement="vertical"
                        current={current}
                        onChange={onChange}
                        // size={isMobile ? "default" : "small"}
                        items={items}
                        responsive={false}     // we handle layout with our media query
                    />
                    <div className="step-details" aria-live="polite">
                        <h3>Step {current + 1} — {stepsData[current].title}</h3>
                        <p>{stepsData[current].description}</p>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default WorkProcess;